import { Route, Routes } from "react-router-dom";


import Home from "../../containers/Home";
import Page404 from "../../pages/Page404";

/**
 * Public route map for the marketing SPA.
 * Translation: Public route map for the marketing SPA.
 *
 * @returns {JSX.Element} Router tree.
 */
const Router = () => (
  <Routes>
    <Route path="/" element={<Home />} />

    <Route path="/404" element={<Page404 />} />
    <Route path="*" element={<Page404 />} />
  </Routes>
);

export default Router;
